import { userDataService } from "./services";
import { UserCard, UserItemPage } from "./components";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { IModuleConfig } from "../../interfaces";
import { ModuleTypeEnum } from "../../enums";
import {
  AddButton,
  CancelButton,
  DeleteButton,
  EditButton,
  SaveButton,
  ExportButton,
} from "./components/toolbar-items";
import {UserPermissions} from "../../definitions"

const config: IModuleConfig = {
  id: "users",
  name: "Users",
  view_permission: UserPermissions.viewUsers,
  edit_permission: UserPermissions.editUsers,
  icon: faUser,
  moduleType: ModuleTypeEnum.DualPaneLibrary,
  allowSearch: true,
  components: {
    libraryCard: UserCard,
    itemPage: UserItemPage,
  },
  services: {
    getByPage: userDataService.getByPage,
    getSingle: userDataService.getSingle,
    create: userDataService.create,
    update: userDataService.update
  },
  utilities: {
    extractKey: (d: any) => d._id,
    extractItemPath: (d: any) => d._id,
    extractItemBreadcrumb: (d: any) => {
      return d.email_address;
    },
  },
  toolbarItems: {
    library: [AddButton, ExportButton],
    create: [CancelButton, SaveButton],
    edit: [CancelButton, SaveButton],
    view: [AddButton, EditButton, DeleteButton],
  },
};

export default config;
